import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface ITermsOfUse_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITermsOfUse_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetTermsOfUse: any[];
  GetTermsOfUse_dummy: any[];
}

export class TermsOfUse_ScreenBase extends React.PureComponent<ITermsOfUse_ScreenProps, any> {
  termsofuse_141516_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "17674926-0bc7-4f1a-91e6-cf803751ca13",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "cd1c3958-6f3d-4c57-92b7-3eacda9ca9b2",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 523642, PropertyName: "value", Value: "Kullanım Koşulları" },
        { Id: 64714, PropertyName: "value", Value: "Hediye Çeki Kullanım Koşulları" },
        { Id: 612160, PropertyName: "title", Value: "Kullanım Koşulları" },
        { Id: 46888, PropertyName: "value", Value: "[datafield:termno]" },
        { Id: 540461, PropertyName: "title", Value: "Kullanım Koşulları" },
        { Id: 298241, PropertyName: "value", Value: "[datafield:termtext]" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.termsofuse_141516_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetTermsOfUse: []
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("termsofuse", "");
      return;
    }

    if (true) {
      await this.TermsOfUsePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("termsofuse", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("termsofuse", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TermsOfUsePageInit();
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  TermsOfUsePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    let localVar = {
      ValidThrough_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ValidThrough ?? this.props.screenInputs.validthrough,
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TermsOfUse/TermsOfUsePageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTermsOfUse = result?.data.getTermsOfUse;

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TermsOfUsePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TermsOfUsePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.dataSource_141516 = this.state.GetTermsOfUse;
    formVars.termsofuse_46888_value = ReactSystemFunctions.value(
      this,
      stateVars.GetTermsOfUse?.length > 0
        ? stateVars.GetTermsOfUse[0].termNo
        : this.state.GetTermsOfUse?.length > 0
        ? this.state.GetTermsOfUse[0].termNo
        : null
    );

    formVars.termsofuse_298241_value = ReactSystemFunctions.value(
      this,
      stateVars.GetTermsOfUse?.length > 0
        ? stateVars.GetTermsOfUse[0].termText
        : this.state.GetTermsOfUse?.length > 0
        ? this.state.GetTermsOfUse[0].termText
        : null
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TermsOfUseComponent_308349_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
  }
}
